import { useState, useCallback } from 'react';
import { useAuth } from './useAuth';
import { hacerSolicitud } from '../helpers/apiClient';
import useEmpresaStore from '../context/empresaStore';


const useObtenerSolicitudes = (url) => {
  const { renovarToken, cerrarSesion } = useAuth();
  const { empresa_ids, empresa_id }  =  useEmpresaStore();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const obtenerSolicitudes = useCallback(async () => {
    setLoading(true);
    setError(null);
    const idsParam = empresa_ids ? empresa_ids.join(',') : empresa_id;
    const urlConEmpresa = `${url}?empresa_id=${idsParam}`

    try {
      const data = await hacerSolicitud(urlConEmpresa, { method: 'GET' }, renovarToken, cerrarSesion);
      return data;
    } catch (err) {
      setError(err.message);
      return null;
    } finally {
      setLoading(false);
    }
  }, [url, renovarToken, cerrarSesion, empresa_ids, empresa_id]);

  return { obtenerSolicitudes, loading, error };
};

export default useObtenerSolicitudes;
